// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"f1ddb9e1","513":"71849de0","703":"d7503b11","787":"d2854929"}[chunkId] + ".chunk.js";
};